import http from '@/api/http';
import { serialize } from '@/utils/tools';

export async function listSt(token, projectId) {
    try {

        // console.log(query);

        const response = await http.get(
            'api/v1/status',
            {
                params: { project: projectId },
                headers: { 'Authorization': 'Bearer ' + token }
            }
        )

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function updateStatus(token, data) {
    try {
        let dataPram = {
            'title': data.title,
            'description': data.description,
            'color': data.color
        }
        if (data.id > 0) {
            dataPram['id'] = data.id
        } else {
            dataPram['project'] = data.project_id
        }

        if (data.flag) {
            dataPram['flag'] = data.flag.id
        }

        // console.log(dataPram);
        const response = await http.post(
            'api/v1/status',
            dataPram,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return error.response.data
    }
}
export async function trashStatus(token, statusId) {
    try {
        const response = await http.get(
            'api/v1/status/trash',
            {
                params: { id: statusId },
                headers: { 'Authorization': 'Bearer ' + token }
            }
        )
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}
export async function restoreStatus(token, statusId) {
    try {
        const response = await http.delete(
            'api/v1/status/trash', 
            {
                params: { id: statusId },
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
            }
        )
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}
export async function restoreStatuses(token, statusIds) {
    try {
        const data = JSON.stringify(statusIds);

        const response = await http.delete(
            'api/v1/status/trash/bulk', 
            {
                params: { ids: data },
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
            }
        )
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}
export async function delStatus(token, statusId) {
    try {
        const response = await http.delete(
            'api/v1/status', 
            {
                params: { id: statusId },
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            }
        )

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}
export async function delStatuses(token, statusIds) {
    try {
        const data = JSON.stringify(statusIds);

        const response = await http.delete(
            'api/v1/status/trash/bulk/permanent', 
            {
                params: { ids: data },
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            }
        )

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}
export async function updateTaskOnce(token, data) {
    try {
        let dataPram = {
            "title": data.title,
            "description": data.description,
            "status": data.status_id,
            "color": data.color,
            "priority": data.priority,
            "completion_percent": data.completion_percent,
            "date_planned_start": data.date_planned_start,
            "date_planned_end": data.date_planned_end,
            "performer": data.performer,
            "controller": data.controller
        }

        if (data.id > 0) {
            dataPram['id'] = data.id
        }

        if (data.pic) {
            dataPram['pic'] = data.pic
        }  
        if (data.isCoverRemoved) {
            dataPram['pic'] = ''
        }

        dataPram['date_planned_start'] = data.date_planned_start ? data.date_planned_start : 0;
        dataPram['date_planned_end'] = data.date_planned_end ? data.date_planned_end : 0;        

        const response = await http.post(
            'api/v1/task-full',
            dataPram,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

/* DEPRECATED */
export async function updateTask(token, data) {
    try {
        let dataPram = {
            'title': data.title,
            'description': data.description,
            'color': data.color,
            'status': data.status_id,
            'priority': data.priority,
            'completion_percent': data.completion_percent
        }
        if (data.id > 0) {
            dataPram['id'] = data.id
        }

        const response = await http.post('api/v1/task',
            dataPram,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}
/* DEPRECATED */
export async function updateSubTask(token, data) {
    try {
        let dataPram = {
            'title': data.title,
            'description': data.description,
            'color': data.color,
            'parent_id': data.parent_id,
            'task': true,
            'priority': data.priority
        }
        if (data.id > 0) {
            dataPram['id'] = data.id
        }

        const response = await http.post(
            'api/v1/subtask',
            dataPram,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            }
        )

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function updateSubTaskOnce(token, data) {
    try {
        let dataPram = {
            "title": data.title,
            "description": data.description,
            "parent_id": data.parent_id,
            "color": data.color,
            "priority": data.priority,
            "task": true,
            "completion_percent": data.completion_percent,
            "date_planned_start": data.date_planned_start,
            "date_planned_end": data.date_planned_end,
            "performer": data.performer,
            "controller": data.controller            
        }

        if (data.id > 0) {
            dataPram['id'] = data.id
        }

        dataPram['date_planned_start'] = data.date_planned_start ? data.date_planned_start : 0;
        dataPram['date_planned_end'] = data.date_planned_end ? data.date_planned_end : 0;

        const response = await http.post(
            'api/v1/subtask-full',
            dataPram,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function updateTaskDate(token, data) {
    try {
        let dataPram = {}

        if (data.date_planned_start) {
            dataPram['start'] = data.date_planned_start
        }

        if (data.date_planned_end) {
            dataPram['end'] = data.date_planned_end
        }

        if (data.id > 0) {
            dataPram['id'] = data.id
        }

        // console.log(dataPram);
        const response = await http.get(
            'api/v1/task/planned-date', 
            {
                params: dataPram,
                headers: {'Authorization': 'Bearer ' + token}
            }
        )

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function updateSubTaskDate(token, data) {
    try {
        let dataPram = {}

        if (data.date_planned_start) {
            dataPram['start'] = data.date_planned_start
        }

        if (data.date_planned_end) {
            dataPram['end'] = data.date_planned_end
        }

        if (data.id > 0) {
            dataPram['id'] = data.id
        }

        // console.log(dataPram);
        const response = await http.get(
            'api/v1/subtask/planned-date',
            {
                params: dataPram,
                headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data', }
            }
        )

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function clearTaskDate(token, data) {
    try {
        let dataPram = {}

        if (!data.date_planned_start) {
            dataPram['start'] = 1
        }

        if (!data.date_planned_end) {
            dataPram['end'] = 1
        }

        if (data.id > 0) {
            dataPram['id'] = data.id
        }

        // console.log(dataPram);
        const response = await http.delete(
            'api/v1/task/planned-date', 
            {
                params: dataPram,
                headers: { 'Authorization': 'Bearer ' + token }
            }
        )

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function clearSubTaskDate(token, data) {
    try {
        let dataPram = {}

        if (!data.date_planned_start) {
            dataPram['start'] = 1
        }

        if (!data.date_planned_end) {
            dataPram['end'] = 1
        }

        if (data.id > 0) {
            dataPram['id'] = data.id
        }

        // console.log(dataPram);
        const response = await http.delete(
            'api/v1/subtask/planned-date',
            {
                params: dataPram,
                headers: {'Authorization': 'Bearer ' + token }
            }
        )

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}
export async function trashTask(token, taskId) {
    try {
        const response = await http.get(
            'api/v1/task/trash',
            {
                params: { id: taskId },
                headers: { 'Authorization': 'Bearer ' + token }
            }
        )
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}
export async function restoreTask(token, taskId) {
    try {
        const response = await http.delete(
            'api/v1/task/trash', 
            {
                params: { id: taskId },
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
            }
        )
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}
export async function restoreTasks(token, taskIds) {
    try {
        const data = JSON.stringify(taskIds);

        const response = await http.delete(
            'api/v1/task/trash/bulk', 
            {
                params: { ids: data },
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
            }
        )
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}
export async function delTask(token, taskId) {
    try {
        const dataPram = { id: taskId } 

        const response = await http.delete(
            'api/v1/task',
            { 
                params: dataPram,
                headers: { 'Authorization': 'Bearer ' + token } 
            }
        )

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}
export async function delTasks(token, taskIds) {
    try {
        const data = JSON.stringify(taskIds);

        const response = await http.delete(
            'api/v1/task/trash/bulk/permanent', 
            {
                params: { ids: data },
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
            }
        )
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}
export async function delSubTask(token, sTaskId) {
    try {
        const dataPram = { id: sTaskId } 

        const response = await http.delete(
            'api/v1/subtask', 
            {
                params: dataPram,
                headers: { 'Authorization': 'Bearer ' + token }
            }
        )

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function archTask(token, taskId) {
    try {
        const dataPram = { 
            id: taskId,
            subtask: false
        } 

        const response = await http.post(
            'api/v2/archive/task', 
            dataPram,
            {
                headers: { 'Authorization': 'Bearer ' + token }
            }
        )

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function archTaskList(token, id) {
    try {
        const dataPram = { project: id } 

        const response = await http.get(
            'api/v2/archive/task', 
            {
                params: dataPram,
                headers: { 'Authorization': 'Bearer ' + token }
            }
        )

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }    
}

export async function listPerformers(token, taskId) {
    try {
        const dataPram = {
            'id': taskId,
            'subtask': false
        }
        const response = await http.get(
            'api/v1/contractor',
            {
                params: dataPram,
                headers: { 'Authorization': 'Bearer ' + token }
            }
        )

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function assignPerformer(token, data) {
    try {
        let dataPram = {
            'id': data.task_id,
            'subtask': data.subtask,
            'user': data.performer_id
        }

        const response = await http.post(
            'api/v1/contractor', 
            dataPram,
            {
                headers: { 
                    'Authorization': 'Bearer ' + token, 
                    'Content-Type': 'multipart/form-data'
                }
            }
        )

        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null        
    }
}

export async function detachPerformer(token, data) {
    try {
        let dataPram = {
            'id': data.task_id,
            'subtask': data.subtask,
            'user': data.performer_id
        }

        const response = await http.get('api/v1/contractor/delete?' + serialize(dataPram), 
            {
                headers: { 
                    'Authorization': 'Bearer ' + token, 
                    'Content-Type': 'application/json'
                }
            })

        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null        
    }
}

export async function listControllers(token, taskId) {
    try {
        // console.log(query);
        const response = await http.get('api/v3/control',
            {
                'id': taskId,
                'subtask': false
            },
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function assignController(token, data) {
    try {
        let dataPram = {
            'id': data.task_id,
            'subtask': data.subtask,
            'user': data.controller_id
        }

        const response = await http.post('api/v3/control', 
            dataPram,
            {
                headers: { 
                    'Authorization': 'Bearer ' + token, 
                    'Content-Type': 'multipart/form-data'
                }
            })

        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null        
    }
}

export async function detachController(token, data) {
    try {
        let dataPram = {
            'id': data.task_id,
            'subtask': data.subtask,
            'user': data.controller_id
        }

        const response = await http.get('api/v3/control/delete?' + serialize(dataPram), 
            {
                headers: { 
                    'Authorization': 'Bearer ' + token, 
                    'Content-Type': 'application/json'
                }
            })

        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null        
    }
}

export async function uploadFiles(token, data) {
    try {
        for (var pair of data.entries()) {
            console.log(pair[0]+ ', ' + pair[1]); 
        }     
        const response = await http.post('api/v1/task/file', data,
            {
                headers: { 
                    'Authorization': 'Bearer ' + token, 
                    'Content-Type': 'multipart/form-data'
                }
            })

        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null        
    }
}

export async function uploadSubFiles(token, data) {
    try {
        for (var pair of data.entries()) {
            console.log(pair[0]+ ', ' + pair[1]); 
        }     
        const response = await http.post('api/v1/subtask/file', data,
            {
                headers: { 
                    'Authorization': 'Bearer ' + token, 
                    'Content-Type': 'multipart/form-data'
                }
            })

        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null        
    }
}

export async function trashFiles(token, filesIds, subFilesIds) {
    try {
        const data1 = JSON.stringify(filesIds);
        const data2 = JSON.stringify(subFilesIds);

        let dataPram = {
            ids_task: data1, 
            ids_subtask: data2
        }
        const response = await http.post(
            'api/v3/files/trash/bulk',
            dataPram,
            {
                params: { ids_task: data1, ids_subtask: data2 },
                headers: { 'Authorization': 'Bearer ' + token }
            }
        )
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function trashFile(token, fileId) {
    try {
        const response = await http.get(
            'api/v3/files/trash',
            {
                params: { id: fileId, is_subtask: false },
                headers: { 'Authorization': 'Bearer ' + token }
            }
        )
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function restoreFile(token, fileId) {
    try {
        const response = await http.delete(
            'api/v3/files/trash', 
            {
                params: { id: fileId, is_subtask: false },
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
            }
        )
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}
export async function restoreFiles(token, filesIds, subFilesIds) {
    try {
        const data1 = JSON.stringify(filesIds);
        const data2 = JSON.stringify(subFilesIds);

        const response = await http.delete(
            'api/v3/files/trash/bulk', 
            {
                params: { ids_task: data1, ids_subtask: data2 },
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
            }
        )
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}
export async function deleteFile(token, id) {
    try {
        const response = await http.delete('api/v1/task/file?id=' + id, {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
        })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}
export async function deleteFiles(token, filesIds, subFilesIds) {
    try {
        const data1 = JSON.stringify(filesIds);
        const data2 = JSON.stringify(subFilesIds);

        const response = await http.delete(
            'api/v3/files/trash/bulk/permanent',
            { 
                params: { ids_task: data1, ids_subtask: data2 },
                headers: { 'Authorization': 'Bearer ' + token } 
            }
        )

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}
export async function trashSubFile(token, fileId) {
    try {
        const response = await http.get(
            'api/v3/files/trash',
            {
                params: { id: fileId, is_subtask: true },
                headers: { 'Authorization': 'Bearer ' + token }
            }
        )
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function restoreSubFile(token, fileId) {
    try {
        const response = await http.delete(
            'api/v3/files/trash', 
            {
                params: { id: fileId, is_subtask: true },
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
            }
        )
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function deleteSubFile(token, id) {
    try {
        const response = await http.delete('api/v1/subtask/file?id=' + id, {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
        })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}
export async function addTaskComment(token, data) {
    try {
        let dataPram = {
            'body': data.body,
            'task_id': data.task_id,
            'subtask': data.subtask,
            'reply': data.replyTo
        }

        // console.log(dataPram);
        const response = await http.post('api/v2/comment',
            dataPram,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}
export async function deleteTaskComment(token, data) {
    try {
        let dataPram = {
            'id': data.id,
            'subtask': data.isSubtask,
        }

        const response = await http.get('api/v2/comment/delete?' + serialize(dataPram), {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
        })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}
export async function searchTags(token, data) {
    try {
        let dataPram = {
            'name': data.name,
            'project': data.projectId
        }

        const response = await http.get('api/v2/hashtag/search?' + serialize(dataPram), {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
        })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}
export async function addTag(token, data) {
    try {
        let dataPram = {
            'name': data.name,
            'task_id': data.task_id,
            'subtask': data.isSubtask
        }

        // console.log(dataPram);
        const response = await http.post('api/v2/hashtag',
            dataPram,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}
export async function removeTag(token, data) {
    try {
        let dataPram = {
            'name': data.name,
            'task_id': data.task_id,
            'subtask': data.isSubtask
        }

        // console.log(dataPram);
        const response = await http.post('api/v2/hashtag/remove',
            dataPram,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}
export async function uploadCover(token, data) {
    try {
        const response = await http.post('api/v1/task/image', data,
            {
                headers: { 
                    'Authorization': 'Bearer ' + token, 
                    'Content-Type': 'multipart/form-data'
                }
            })
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null        
    }
}
export async function removeCover(token, id) {
    try {
        const response = await http.delete('api/v1/task/image?id=' + id, {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
        })
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}
export async function completeTask(token, data) {
    try {
        let response,
            url = 'api/v1/task/completed-date?id=' + data.id,
            h = { headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data'} }

        if (data.complete) {
            response = await http.get(url, h)
        } else {
            response = await http.delete(url, h)
        }
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null        
    }
}
export async function completeSubTask(token, data) {
    try {
        let response,
            url = 'api/v1/subtask/completed-date?id=' + data.id,
            h = { headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data'} }

        if (data.complete) {
            response = await http.get(url, h)
        } else {
            response = await http.delete(url, h)
        }
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null        
    }
}
export async function updateCheck(token, data) {
    try {
        let dataParam = {
            'is_done': data.is_done
        }

        if (data.id) {
            dataParam["id"] = data.id
        }
        if (data.id_task) {
            dataParam["id_task"] = data.id_task
        }        
        if (data.name) {
            dataParam["name"] = data.name
        }        
        
        const response = await http.post('api/v1/task/check',
            dataParam,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}
export async function deleteCheck(token, id) {
    try {
        let dataPram = {
            'id': id
        }

        const response = await http.get('api/v1/task/check-del?' + serialize(dataPram), {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
        })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}
export async function sortColumns(token, data) {
    try {
        let dataPram = {
            'ids': data
        }

        // console.log(dataPram);
        const response = await http.post('api/v1/status/sort-status',
            dataPram,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}
export async function sortTasks(token, data) {
    try {
        let dataPram = {
            'id': data.id,
            'id_prev': data.prevId,
            'id_status': data.statusId
        }

        // console.log(dataPram);
        const response = await http.post('api/v1/status/sort-tasks',
            dataPram,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}
export async function openTask(token, taskId) {
    try {
        const response = await http.get(
            '/api/v1/task/open',
            {
                params: { id: taskId },
                headers: { 'Authorization': 'Bearer ' + token }
            }
        )
        return response.data
    } catch (error) {
        return {}
    }  
}
export async function closeTask(token, taskId) {
    try {
        const response = await http.get(
            '/api/v1/task/open',
            {
                params: { id: taskId, close: true },
                headers: { 'Authorization': 'Bearer ' + token }
            }
        )
        return response.data
    } catch (error) {
        return {}
    }  
}
export async function sortAll(token, data) {
    try {
        let dataPram = {
            'ids': data
        }

        // console.log(dataPram);
        const response = await http.post('api/v1/status/sort',
            dataPram,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}
export async function fetchFlags(token) {
    try {
        const response = await http.get('api/v1/status/flags', {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
        })
        return response.data
    } catch (error) {
        return []
    }
}
export async function trashbin(token, projectId) {
    try {
        const response = await http.get(
            'api/v3/trash-project',
            {
                params: { id: projectId },
                headers: { 'Authorization': 'Bearer ' + token }
            }
        )
        return response.data
    } catch (error) {
        return []
    }
}